export const getUserFullName = (user, defaultValue = '') => {
  if (!user) return defaultValue;
  const fullName = `${user.firstName ? user.firstName : ''}${user?.middleName ? ` ${user?.middleName}` : ''}${user?.lastName ? ` ${user?.lastName}` : ''}${user?.secondName ? ` ${user?.secondName}` : ''}`;
  return fullName?.trim() || defaultValue;
};
